import { Link } from 'react-router-dom';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

// Layout público compartido para las páginas legales (privacidad, términos, eliminación de datos).
// No requiere login — accesible para revisores de Meta y usuarios finales.
function LegalPage({ title, subtitle, sections, updatedAt }) {
  const isMobile = useIsMobile();
  return (
    <main style={{ padding: isMobile ? '2rem 1rem' : '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: isMobile ? '1.75rem 1.25rem' : '2.5rem',
        width: '100%',
        maxWidth: '760px',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <h1 style={{ color: theme.colors.primary, marginBottom: '0.4rem', fontSize: '1.6rem' }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ color: theme.colors.textMuted, fontSize: '0.85rem', marginBottom: '0.4rem' }}>
            {subtitle}
          </p>
        )}
        {updatedAt && (
          <p style={{ color: theme.colors.textMuted, fontSize: '0.78rem', marginBottom: '2rem' }}>
            Última actualización: {updatedAt}
          </p>
        )}

        {sections.map((section, i) => (
          <div key={i} style={{ marginBottom: '1.4rem' }}>
            <h2 style={{ color: theme.colors.primary, fontSize: '1rem', fontWeight: '700', marginBottom: '0.45rem' }}>
              {section.title}
            </h2>
            <p style={{ color: theme.colors.text, fontSize: '0.92rem', lineHeight: '1.75', margin: 0, whiteSpace: 'pre-line' }}>
              {section.content}
            </p>
          </div>
        ))}

        <div style={{ borderTop: `1px solid ${theme.colors.border}`, marginTop: '2rem', paddingTop: '1.2rem' }}>
          <Link to="/" style={{ color: theme.colors.primary, fontSize: '0.9rem', textDecoration: 'none' }}>
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}

export default LegalPage;
